import styled from 'styled-components';

import { mediaMin } from '@spa/shared/theme';

export const Wrapper = styled.div`
  display: flex;
  ${({ theme }) => theme.gap(2)};
  align-items: center;
  font-size: ${props => props.theme.rem(14)};
  line-height: ${props => props.theme.rem(24)};
  color: ${props => props.theme.colors.mountainMeadow};
  font-weight: 600;

  ${mediaMin.mediumBreakpoint`
    min-height: min-content;
  `}
`;
